/**
 * Auto-generated version information
 * DO NOT EDIT THIS FILE MANUALLY
 * Generated from git tags by scripts/generate-version.js
 */

export const APP_VERSION = '26.8.0';
